export const dropFrameFPS = new Set(['29.97', '59.94']);

export const getIsDropFrame = (
  fps: number | undefined,
  dropFrame: boolean | undefined,
): boolean => {
  if (!fps || !dropFrame) {
    return false;
  }
  const fpsFormat = fps.toFixed(2);
  return dropFrame && dropFrameFPS.has(fpsFormat);
};
